import React from 'react';
import { Link } from 'react-router-dom';
// import blogs from '../../api/blogs';

// import { Link } from 'react-router-dom'
import projMan from '../../images/projSub.jpg'
import blog4 from '../../images/blog-details/comments-author/img-2.jpg'
import blog5 from '../../images/blog-details/comments-author/img-3.jpg'
import blog6 from '../../images/blog-details/author.jpg'
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';
import Secretary from '../../images/studentReq.jpg';


// const ClickHandler = () => {
//     window.scrollTo(10, 0);
// }

const GeneralManager = (props) => {

    const { slug } = useParams()

    const BlogDetails = blogs.find(item => item.slug === slug)

    const submitHandler = (e) => {
        e.preventDefault()
    }

  return (
    <section className="blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-9 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            

                            <div className="tag-share">
                            <div className="post format-standard-image">
                                <div className="entry-media">
                                    <img src={Secretary} alt="" />
                                </div>
                                <ul className="entry-meta">
                                    <li><Link to="">FFSD GROUP</Link></li>
                                    <li><Link to="">18th November, 2025.</Link></li>
                                    <li><Link to="">Application Deadline: 12th December 2025.</Link></li>
                                </ul>
                                <h2>Job Title: General Manager <br /> Location: Lagos, Nigeria. <br/> Reports To: Deputy Chief Executive Officer (DCEO)</h2>
                                
                                <h3>ROLE SUMMARY</h3>
                                <p>The General Manager (GM) provides strategic leadership and operational oversight across the company brands. The role ensures business growth, operational efficiency, strong team performance, and high-quality service delivery. The GM acts as the central coordinator between management and all departments, driving execution, accountability, and profitability.</p>
                                
                                <h3>KEY RESPONSIBILITIES</h3>
                                <p>
                                    <strong>1. Strategic Leadership & Multi-Brand Oversight</strong><br />
                                    • Lead day-to-day operations and ensure alignment with company goals.<br />
                                    • Drive cross-department coordination, communication, and accountability.<br />
                                    • Lead weekly management/operations meetings and provide strategic updates.<br /><br />

                                    <strong>2. Business Performance</strong><br />
                                    • Oversee budgeting, forecasting, and quarterly financial reviews.<br />
                                    • Drive revenue growth through partnerships, innovation, and market expansion.<br /><br />

                                    <strong>3. Project & Operational Management</strong><br />
                                    • Oversee key projects ensuring timely execution and quality standards.<br />
                                    • Implement and refine SOPs to strengthen operational efficiency.<br /><br />

                                    <strong>4. Talent Management</strong><br />
                                    • Support employee development, training, and succession planning.<br />
                                    • Maintain a positive work environment and ensure policy compliance.<br /><br />

                                    <strong>5. Performance Management & Reporting</strong><br />
                                    • Set and monitor KPIs for all departments ensuring accountability.<br />
                                    • Review performance reports and implement corrective actions.<br />
                                    • Enhance employee engagement and productivity systems.<br /><br />

                                    <strong>6. Customer Experience & Quality Assurance</strong><br />
                                    • Ensure exceptional service delivery across all business units.<br />
                                    • Monitor client feedback and resolve escalations promptly.<br />
                                    • Champion continuous improvement in customer satisfaction.<br /><br />

                                    <strong>7. Compliance, Risk & External relations</strong><br />
                                    • Ensure compliance with industry regulations and data protection standards.<br />
                                    • Identify operational risks and implement mitigation strategies.<br />
                                    • Represent the company in external stakeholder engagements and partnerships.<br />
                                </p>

                                <h3>REQUIRED SKILLS & COMPETENCIES</h3>
                                <p>
                                    • Proven leadership and multi-team management ability<br />
                                    • Strategic thinking and decision-making<br />
                                    • Project and performance management expertise<br />
                                    • Strong analytical, financial, and problem-solving abilities<br />
                                    • Excellent communication and stakeholder management<br />
                                </p>

                                <h3>QUALIFICATIONS</h3>
                                <p>
                                    • Bachelor's degree in Business, Management, HR, or related field<br />
                                    • Master's degree or relevant certification is an advantage.<br />
                                    • 4-6 years' experience in a managerial role in service-based organization<br />
                                    • Demonstrated experience in operations, team supervision, and business performance improvement.<br />
                                </p>

                                <h3>How to Apply</h3>
                                <p>
                                If you meet the qualifications and are ready to take on this challenging role, please send your CV and a cover letter to <a href="mailto:careers@ffsdgroup.com"> careers@ffsdgroup.com </a> with the job title "General Manager" as the subject. 
                                </p>
                            </div>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
  )
}

export default GeneralManager;